<template>
  <div class="flex flex-col min-h-screen bg-cover bg-blend-overlay dark:bg-black/30" :style="{ backgroundImage: `url( ${propsStore.loginBg})` }">
    <SiteHeader :page-name="''" :logged-in="false" />
    <div class="w-full m-auto">
      <LoginPanel v-if="activePanel === 'LOGIN'" :adminLogin="false" @navigate="(to) => (activePanel = to)"></LoginPanel>
      <ForgotPasswordPanel v-else-if="activePanel === 'PASSWORD'" :adminLogin="false" @navigate="(to) => (activePanel = to)"></ForgotPasswordPanel>
      <ForgotUsernamePanel v-else-if="activePanel === 'USERNAME'" :adminLogin="false" @navigate="(to) => (activePanel = to)"></ForgotUsernamePanel>
    </div>
  </div>
</template>

<script setup lang="ts">
import { usePropsStore } from "@/stores/props";

const activePanel = ref<"LOGIN" | "PASSWORD" | "USERNAME">("LOGIN");
const propsStore = usePropsStore();
</script>
